export function canManageMarketingCampaigns(state) {
    return Boolean(state?.config?.permission?.marketingCampaignsManagement);
}

export function canAccessMarketingCampaigns(state) {
    const { marketingCampaignsManagement, marketingCampaignsGeneral } =
        state?.config?.permission ?? {};
    return Boolean(marketingCampaignsManagement || marketingCampaignsGeneral);
}
